
// 这个service里面的方法是给申请表字段配置中配置了dataSet为8的时候使用的
export default {

  /**
   * 根据出生日期获取年龄
   * @param {String} birthday 出生日期
   * @return {Number}
   */
  getAge(birthday) {
    if (birthday) {
      const birthdayDate = new Date(birthday);
      const nowDate = new Date();
      let age = nowDate.getFullYear() - birthdayDate.getFullYear();
      if ((nowDate.getMonth() === birthdayDate.getMonth() && nowDate.getDate() < birthdayDate.getDate())
        || nowDate.getMonth() < birthdayDate.getMonth()) {
        // 说明生日还没到
        age -= 1;
      }
      return age > 0 ? age : 0;
    }
  },

  /**
   * 根据开始结束日期获取时间间隔
   * @param {String} startDate 开始日期
   * @param {String} endDate 结束日期
   */
  getDays(startDate, endDate) {
    if (startDate && endDate) {
      const startDateObj = new Date(startDate);
      const endDateObj = new Date(endDate);
      let stay = endDateObj.getTime() - startDateObj.getTime();
      stay = stay > 0 ? stay : 0;
      return Math.ceil(stay / 86400000) + 1;
    }

    return '';
  },

  /**
   * 获取年和月
   * @param {String} startTime 开始时间
   * @param {String} endTime 结束时间
   */
  getYearAndMonth(startTime, endTime) {
    let result = '';
    let et = null;
    if (startTime) {
      const st = new Date(startTime);
      if (endTime) {
        // 如果有终止日期
        et = new Date(endTime);
      } else {
        // 没有就当前日期
        et = new Date();
      }

      if (et.getFullYear() >= st.getFullYear()) {
        const month = (et.getFullYear() - st.getFullYear()) * 12 + et.getMonth() - st.getMonth();
        if (month < 0) {
          result = '';
        } else if (month === 0) {
          // 不足一个月按一个月算
          result = '1 MONTH';
        } else if (parseInt(month / 12, 10) >= 1) {
          if (month % 12 !== 0) {
            result = `${parseInt(month / 12, 10)} ${parseInt(month / 12, 10) === 1 ? 'YEAR' : 'YEARS'} AND ${month % 12} ${month % 12 === 1 ? 'MONTH' : 'MONTHS'}`;
          } else {
            result = `${parseInt(month / 12, 10)} ${parseInt(month / 12, 10) === 1 ? 'YEAR' : 'YEARS'}`;
          }
        } else {
          result = `${month} ${month === 1 ? 'MONTH' : 'MONTHS'}`;
        }
      }
    }
    return result;
  },
};



// WEBPACK FOOTER //
// ./src/services/application-hidden-field-service.js